import React, { useEffect, useCallback } from 'react';
import { Typography, Box, CircularProgress } from '@mui/material';
import { useSession } from '../context/SessionContext';
import { APP_NAME, RELEASE_VERSION } from '../config/release';

const Logout: React.FC = () => {
  const { logoutUser } = useSession();

  const handleLogout = useCallback(async () => {
    await logoutUser();
  }, [logoutUser]);

  useEffect(() => {
    handleLogout();
  }, [handleLogout]);

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        height: '90vh',
        backgroundColor: 'background.default',
        color: 'text.primary',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
          maxWidth: 600,
          backgroundColor: 'background.paper',
          padding: 3,
          borderRadius: 2,
          boxShadow: 3,
          textAlign: 'center',
        }}
      >
        <CircularProgress sx={{ mb: 2, color: 'white' }} />
        <Typography variant="h6" gutterBottom>
          Thank you for using the
        </Typography>
        <Typography variant="h4" gutterBottom>
          Black Widow Imaging
        </Typography>
        <Typography variant="h4" gutterBottom>
          Unified Management System
        </Typography>
      </Box>
      <Typography
        variant="body2"
        align="center"
        sx={{
          marginTop: 3,
          color: 'text.secondary',
        }}
      >
        {APP_NAME} &nbsp;&nbsp; Version: {RELEASE_VERSION}
      </Typography>
    </Box>
  );
};

export default Logout;
